import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { supabase } from '@/lib/supabase';

/**
 * Magic-link redirect target. Exchanges the auth code in the URL for a session,
 * then redirects to the dashboard (or the page the user originally tried to reach).
 */
export function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      const code = new URL(window.location.href).searchParams.get('code');
      if (code) {
        const { error } = await supabase.auth.exchangeCodeForSession(code);
        if (error) {
          toast.error(error.message);
          navigate('/login', { replace: true });
          return;
        }
      }
      navigate('/', { replace: true });
    };
    void run();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg">
      <div className="text-center">
        <p className="display-serif text-3xl text-fg">Signing you in…</p>
        <p className="mt-2 text-sm text-fg-muted">Just a moment.</p>
      </div>
    </div>
  );
}